<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <PageTitle title="Назначение конкурса"/>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-btn
        small
        outlined
        rounded
        :disabled="!selected.length"
        :loading="appointLoading"
        color="primary"
        class="white--text px-4 mr-2"
        @click="appoint"
      >
        <v-icon left small>mdi-plus</v-icon>
        Назначить конкурс
      </v-btn>

      <v-btn
        small
        outlined
        rounded
        color="primary"
        :disabled="!selected.length"
        :loading="cancelLoading"
        class="white--text px-4 mr-2"
        @click="cancel"
      >
        <v-icon left small>mdi-minus</v-icon>
        Отменить конкурс
      </v-btn>
    </v-col>

    <v-col cols="12">
      <PageTable
        v-model="selected"
        show-select
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        filter
        :table-items="vacancyParent.list"
        table-height="284"
      >
        <template v-slot:button>
          <v-badge
            overlap dot
            :value="!!checkFilterProperties"
          >
            <v-btn
              v-if="checkRoles"
              small rounded outlined
              color="primary"
              class="white--text ml-4 filter-btn"
              @click="showFilter = !showFilter"
            >
              <v-icon left small>mdi-filter-outline</v-icon>
              <span>{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>
            </v-btn>
          </v-badge>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Просмотр" @click="show(item)">
            mdi-eye
          </v-icon>
        </template>
      </PageTable>

      <transition name="curator-filter">
        <ContestFilterDialog
          v-show="showFilter"
          @applyFilter="applyFilter"
          @closeFilter="showFilter = false"
          :vacancy-filter="vacancyFilter"
          width-filter="300"
          top="255"
          right="29"
        />
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import {vacancyApi, applicationApi} from '@/api'
import PageTitle from '@/components/ui/Title'
import PageTable from '@/components/ui/Table'
import {
  VacancyFilter,
  VacancyParent
} from '@/models'
import {
  mapGetters, mapMutations,
  mapState
} from "vuex"
import ContestFilterDialog from "@/components/zvp/contestPage/ContestFilterDialog"

export default {
  name: 'Vacancies',

  components: {
    VacancyFilter,
    PageTitle,
    PageTable,
    ContestFilterDialog,
  },

  created() {
    if (!this.checkRoles) this.$router.push('/')
  },

  data: () => ({
    selected: [],
    tableHeaders: [
      { text: 'Номер курса', value: 'courseNumber.name', sortable: false, align: 'start' },
      { text: 'Специальность', value: 'speciality.name', sortable: false, align: 'start' },
      { text: 'Тип обучения', value: 'paidForm.name', sortable: false, align: 'start' },
      { text: 'Места', value: 'quantity', sortable: false, align: 'start'},
      { text: 'Количество принятых заявлений', value: 'applicationCount', sortable: false, align: 'start'},
      { text: 'Конкурс', value: 'vacancyStatus.name', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '100px' },
    ],
    vacancyParent: new VacancyParent(),

    tableLoading: false,
    cancelLoading: false,
    appointLoading: false,

    showFilter: false,

    confirmDialog: false,
    dialog: false,

    pageNumber: 0,
    lastPage: false,
  }),

  computed: {
    ...mapState('system', ['dataLoaded']),
    ...mapGetters('user', ['isCurator', 'isAdmin']),
    ...mapGetters('vacancyFilter', ['vacancyFilter']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },

    checkFilterProperties() {
      for(const item in this.vacancyFilter) {
        if (this.vacancyFilter[item]?.id) return true
      }

      return false
    },
  },

  methods: {
    ...mapMutations('vacancyFilter', ['setVacancyFilter']),

    async appoint() {
      try {
        this.appointLoading = true
        for (const item of this.selected) {
          const data = await applicationApi.appointCompetition(item.id)
          const vacancy = await vacancyApi.get(item.id)
          this.vacancyParent.update(vacancy)
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.appointLoading = false
      }
    },

    async cancel() {
      try {
        this.cancelLoading = true
        for (const item of this.selected) {
          const data = await applicationApi.cancelCompetition(item.id)
          const vacancy = await vacancyApi.get(item.id)
          this.vacancyParent.update(vacancy)
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.cancelLoading = false
      }
    },

    async getVacancies() {
      this.tableLoading = true
      try {
        if (!this.lastPage) {
          const { last, content } = await vacancyApi.findAllByFilter(this.pageNumber, this.vacancyFilter)

          content?.length && this.vacancyParent.build(content)
          this.lastPage = last
          this.pageNumber++
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.tableLoading = false
      }
    },

    async applyFilter(item) {
      this.vacancyParent.list = []
      this.lastPage = false
      this.pageNumber = 0
      this.setVacancyFilter(item || new VacancyFilter())
      await this.getVacancies()
    },

    show(item) {
      this.$router.push(`contest-line-page/${item.id}`)
    }
  },

  watch: {
    dataLoaded: {
      immediate: true,
      async handler(value) {
        if (value) {
          await this.getVacancies()
        }
      }
    }
  }
}
</script>

<style scoped>

.curator-filter-enter-active {
  transition: opacity .2s;
}

.curator-filter-leave-active {
  transition: opacity .2s;
}

.curator-filter-enter, .curator-filter-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}

.upload-excel-input {
  display: none;
}
</style>
